export const isLogined = state => state.isLogined
export const isLoading = state => state.isLoading
export const cartList = state => state.cartList
export const receiveInCart = state => state.receiveInCart
export const showCart = state => state.showCart
export const showMoveImg = state => state.showMoveImg
export const elLeft = state => state.elLeft
export const elTop = state => state.elTop
export const moveImgUrl = state => state.moveImgUrl
export const cartPositionT = state => state.cartPositionT
export const cartPositionL = state => state.cartPositionL



// WEBPACK FOOTER //
// ./src/store/getters.js